import React, { useState } from 'react';

/**
 * Faq — accessible accordion (05 §2.6). Multiple items can be open at once.
 * The first item is open by default.
 */
const Faq = ({ items, idPrefix = 'faq' }) => {
  const [open, setOpen] = useState(() => {
    const s = {};
    if (items.length > 0) s[0] = true;
    return s;
  });

  const toggle = (i) => {
    setOpen((prev) => ({ ...prev, [i]: !prev[i] }));
  };

  return (
    <div className="cy-faq">
      {items.map((item, i) => {
        const isOpen = !!open[i];
        const qId = `${idPrefix}-q-${i}`;
        const aId = `${idPrefix}-a-${i}`;
        return (
          <div className="cy-faq__item" key={i}>
            <h3 style={{ margin: 0 }}>
              <button
                type="button"
                className="cy-faq__q"
                aria-expanded={isOpen}
                aria-controls={aId}
                id={qId}
                onClick={() => toggle(i)}
              >
                <span>{item.q}</span>
                <span className="cy-faq__icon" aria-hidden="true">
                  {isOpen ? '\u2212' : '+'}
                </span>
              </button>
            </h3>
            <div
              className={`cy-faq__body${isOpen ? ' is-open' : ''}`}
              id={aId}
              role="region"
              aria-labelledby={qId}
            >
              <div className="cy-faq__body-inner">
                <p>{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Faq;
